module.exports = __webpack_public_path__ + "static/media/loadingLogo.a8fa16f9.png";